"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.rule = void 0;
const GenericValidator_1 = require("./GenericValidator");
exports.rule = (config) => new GenericValidator_1.GenericValidator(config, (value) => !value || value.length <= config.maxlength, "Maximum length exceeded for '%s'");
exports.NAME = 'MAXLENGTH';
//# sourceMappingURL=MaxLengthRule.js.map